import "./PositionsUSA.css";
import useUSPosition from "../../hooks/useUSPosition";

import { ignoreEnter, handleFigureChange, handleFigureBlur } from "./utils/inputhandlers";
import useUSUndo from "../../hooks/useUSUndo";

const USPositionFormGroup = ({ labelname, inputname, inputtype, style, readOnly, type, rowStyle, cplaceholder }) => {
  // Load context data
  const { USposition, setUSposition, setUSpositionData } = useUSPosition();
  const { positionEdits, editID, setEditID, editingField, setEditingField, undoList, inputRefs } = useUSUndo();

  return (
    <div className='form-group' style={rowStyle}>
      <label>{labelname}:</label>
      {readOnly ? (
        <input
          readOnly
          disabled
          type={type || "text"}
          style={{ border: "none" }}
          autoComplete='off'
          onKeyDown={ignoreEnter}
          onFocus={(e) => e.target.select()}
          value={USposition?.[inputname] || ""}
          name={inputname}
          tabIndex={-1}
        />
      ) : (
        <input
          required
          type={type || "text"}
          name={inputname}
          value={USposition?.[inputname] ? USposition?.[inputname] : USposition?.[inputname] === 0 ? 0 : ""}
          autoComplete='off'
          onKeyDown={ignoreEnter}
          onFocus={(e) => e.target.select()}
          onChange={(e) => handleFigureChange(e, inputtype, setUSposition, setUSpositionData, setEditingField)}
          onBlur={(e) =>
            handleFigureBlur(
              e,
              inputtype,
              setUSposition,
              positionEdits,
              editID,
              setEditID,
              editingField,
              setEditingField,
              undoList
            )
          }
          style={style}
          placeholder={cplaceholder}
          ref={(el) => (inputRefs.current[inputname] = el)}
        />
      )}
    </div>
  );
};

export default USPositionFormGroup;
